"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));
var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));
var _core2 = require("@stt-componentes/core");
var _SttCard = _interopRequireDefault(require("./SttCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    containerCarrossel: {
      position: "relative",
      width: "100%",
      paddingLeft: theme.spacing(1.2)
    },
    carrossel: {
      overflow: "hidden",
      position: "relative"
    },
    trilhaCarrossel: {
      display: "flex",
      transition: "transform 0.5s cubic-bezier(0.4, 0.0, 0.2, 1)"
    },
    itemCard: {
      minWidth: 0,
      paddingRight: theme.spacing(2),
      boxSizing: "border-box"
    },
    botaoCarrossel: {
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 10,
      backgroundColor: "transparent",
      transition: "all 0.3s ease",
      boxShadow: "none",
      width: "auto",
      height: "auto",
      padding: 0,
      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    botaoCarrosselEsquerda: {
      left: "-10px"
    },
    botaoCarrosselDireita: {
      right: "-10px"
    },
    seta: {
      fontSize: 25,
      color: theme.palette.primary.main
    }
  };
});
var SttCardCarousel = function SttCardCarousel(_ref) {
  var _ref$cursos = _ref.cursos,
    cursos = _ref$cursos === void 0 ? [] : _ref$cursos,
    _acessar = _ref.acessar,
    visualizar = _ref.visualizar,
    onFavoritar = _ref.onFavoritar,
    count = _ref.count,
    page = _ref.page,
    totalRegistros = _ref.totalRegistros,
    onRowsPerPageChange = _ref.onRowsPerPageChange;
  var classes = useStyles();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    indiceAtual = _useState2[0],
    setIndiceAtual = _useState2[1];
  var _useState3 = (0, _react.useState)(4),
    _useState4 = _slicedToArray(_useState3, 2),
    cartoesPorVisualizacao = _useState4[0],
    setCartoesPorVisualizacao = _useState4[1];
  var carrosselRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var aoRedimensionar = function aoRedimensionar() {
      var largura = window.innerWidth;
      if (largura < 600) {
        setCartoesPorVisualizacao(1);
      } else if (largura < 960) {
        setCartoesPorVisualizacao(2);
      } else if (largura < 1280) {
        setCartoesPorVisualizacao(3);
      } else {
        setCartoesPorVisualizacao(4);
      }
    };
    aoRedimensionar();
    window.addEventListener("resize", aoRedimensionar);
    return function () {
      return window.removeEventListener("resize", aoRedimensionar);
    };
  }, []);
  if (!cursos || cursos.length === 0) {
    return null;
  }
  var indiceMaximo = Math.max(0, cursos.length - cartoesPorVisualizacao);
  var totalCarregados = count && page !== undefined ? (page + 1) * count : cursos.length;
  var temMaisCursosBackend = totalRegistros ? totalCarregados < totalRegistros : false;
  var aoVoltar = function aoVoltar() {
    var passo = cartoesPorVisualizacao === 1 ? 1 : cartoesPorVisualizacao;
    setIndiceAtual(function (anterior) {
      return Math.max(0, anterior - passo);
    });
  };
  var aoAvancar = function aoAvancar() {
    var passo = cartoesPorVisualizacao === 1 ? 1 : cartoesPorVisualizacao;
    var novoIndice = Math.min(indiceMaximo, indiceAtual + passo);
    var cursosRestantes = cursos.length - (novoIndice + cartoesPorVisualizacao);
    var limiteCarregamento = cartoesPorVisualizacao * 2;
    if (cursosRestantes < limiteCarregamento && temMaisCursosBackend && onRowsPerPageChange) {
      var novoCount = count + cartoesPorVisualizacao;
      onRowsPerPageChange({
        target: {
          value: novoCount
        }
      });
    }
    setIndiceAtual(novoIndice);
  };
  var podeVoltar = indiceAtual > 0;
  var podeAvancar = indiceAtual < indiceMaximo;
  var larguraCartao = 100 / cartoesPorVisualizacao;
  var traduzirX = -(indiceAtual * larguraCartao);
  return /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.containerCarrossel
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    className: classes.carrossel
  }, /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
    ref: carrosselRef,
    className: classes.trilhaCarrossel,
    style: {
      transform: "translateX(".concat(traduzirX, "%)")
    }
  }, cursos.map(function (curso, indice) {
    return /*#__PURE__*/_react["default"].createElement(_core2.SttGrid, {
      key: curso.id || indice,
      item: true,
      className: classes.itemCard,
      style: {
        flex: "0 0 ".concat(larguraCartao, "%")
      }
    }, /*#__PURE__*/_react["default"].createElement(_SttCard["default"], {
      id: curso.id,
      index: indice,
      turma: curso.turma,
      url: curso.url,
      titulo: curso.titulo,
      conteudo_arquivo: curso.conteudo_arquivo,
      dataInicio: curso.data_inicio,
      dataFim: curso.data_fim,
      instituicao: curso.instituicao,
      situacaoCurso: curso.situacaoCurso,
      situacaoInscricao: curso.situacaoInscricao,
      tenho_interesse: curso.tenho_interesse,
      acessar: function acessar() {
        return _acessar && _acessar(curso.url);
      },
      visualizar: visualizar,
      onFavoritar: onFavoritar
    }));
  }))), podeVoltar && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    className: "".concat(classes.botaoCarrossel, " ").concat(classes.botaoCarrosselEsquerda),
    onClick: aoVoltar
  }, /*#__PURE__*/_react["default"].createElement(_ArrowBackIos["default"], {
    className: classes.seta
  })), podeAvancar && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    className: "".concat(classes.botaoCarrossel, " ").concat(classes.botaoCarrosselDireita),
    onClick: aoAvancar
  }, /*#__PURE__*/_react["default"].createElement(_ArrowForwardIos["default"], {
    className: classes.seta
  })));
};
var _default = SttCardCarousel;
exports["default"] = _default;